module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/090-burkina-faso-eae3646144edade4024010a2672a2057.svg";